import { alertSounds } from "../globals";

export function playAlertSound(delay = 1000) {
  if (document.getElementById("alert-sound")) return;
  const audio = document.createElement("audio");
  audio.id = "alert-sound";
  audio.src = alertSounds.huthut;
  document.body.appendChild(audio);
  audio.play();
  audio.addEventListener("ended", () => {
    // The timeout is a temporary workaround to prevent duplicate
    // beeps until the backend alert system is properly fixed.
    setTimeout(() => {
      document.getElementById("alert-sound")?.remove();
    }, delay);
  });
}
